import React from 'react';
import { WeddingWebsiteQuery } from '../../generated/graphql';
import styles from './QuestionList.scss';

export type GuestWeddingQuestions = NonNullable<NonNullable<WeddingWebsiteQuery['guestWedding']>['questions']>;

interface Props {
  questions: GuestWeddingQuestions;
}

const QuestionList: React.FC<Props> = ({ questions }) => (
  <div className={styles.quoteIndent}>
    {questions.map(question => {
      const optionLength = question?.options?.length || 0;
      const hasOptions = question.answerType === 'Option' && !!optionLength;
      return (
        <div key={question.id} className={styles.questionLine}>
          {question.text}
          {hasOptions && <span>&nbsp;&nbsp;({optionLength} options)</span>}
        </div>
      );
    })}
  </div>
);

export default QuestionList;
